const normalizeText = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();

const getMomentText = (scene = {}) => normalizeText(
  scene.body
  || scene.content
  || scene.text
  || scene.note
  || scene.description
  || scene.summary
  || scene.sourceText
);

export const buildOrganizedCaptureDraft = (scenes = []) => scenes
  .map((scene) => {
    const title = normalizeText(scene.title || scene.titlePrefix || scene.categoryLabel || scene.category || 'Moment');
    const body = getMomentText(scene);
    const date = normalizeText(scene.occurredOnDate || scene.metadata?.timelinePlanner?.occurredOnDate || '');
    return [date, title, body && body.toLowerCase() !== title.toLowerCase() ? body : '']
      .filter(Boolean)
      .join(' — ');
  })
  .filter(Boolean)
  .join('\n');
